import api from "../../api";

export const  PAGE_CONFIG = (tr) => {
    return {
        PAGE_DESCRIPTION: tr('pageDescription'),
        BREADCRUMB: [
            { label: 'Home', link: '/' },
        { label: 'Books', link: '/books' }
    ],
    PAGE_TITLE: tr('pageTitle'),
    GET_QUERY_KEY: 'books',
    SEARCH_DESCRIPTION: tr('searchDescription'),
    SEARCH_PLACEHOLDER: tr('searchPlaceholder'),
    SEARCH_LOADING_MESSAGE: tr('searchLoadingMessage'),
    API_CALL: () => api.upload.getUploads(),
    DEFAULT_ERROR_MESSAGE: tr('defaultErrorMessage'),
    SELECT: (data) => data?.data
    };
};
